import React, { Fragment } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
export var CheckboxUncheckedIcon = function CheckboxUncheckedIcon() {
  return (
    /*#__PURE__*/
    React.createElement(SvgIcon, {
      style: {
        width: 20,
        height: 20
      }
    },
    /*#__PURE__*/
    React.createElement(Fragment, null,
    /*#__PURE__*/
    React.createElement("g", {
      transform: "translate(1 1)"
    },
    /*#__PURE__*/
    React.createElement("rect", {
      className: "ds_switch_outline",
      width: "22",
      height: "22"
    }))))
  );
};